import { LegalPage } from "@/components/LegalPage";
import { IubendaEmbed } from "@/components/IubendaEmbed";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" hideNote>
      <IubendaEmbed url="https://www.iubenda.com/privacy-policy/14124580" label="Privacy Policy" />
    </LegalPage>
  );
}
